export default __webpack_public_path__ + "static/media/imei.f410fd07.svg";